module.exports = __webpack_public_path__ + "static/media/rules.0fc930b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/rules.png
// module id = 1617
// module chunks = 0